import { AlertTriangle, CheckCircle2, Info, LoaderCircle, X } from 'lucide-react'

export function Button({ children, variant = 'primary', icon: Icon, className = '', ...props }) {
  return (
    <button className={`button button--${variant} ${className}`} {...props}>
      {Icon ? <Icon aria-hidden="true" /> : null}
      <span>{children}</span>
    </button>
  )
}

export function StatusTag({ status, children }) {
  const labels = { completed: '完了', review: '要確認', missing: '未実施', pending: '確認待ち' }
  return <span className={`status-tag status-tag--${status}`}>{children || labels[status] || status}</span>
}

export function EmptyState({ title = '該当するデータがありません', detail }) {
  return (
    <div className="empty-state">
      <Info aria-hidden="true" />
      <strong>{title}</strong>
      {detail ? <p>{detail}</p> : null}
    </div>
  )
}

export function Modal({ open, title, children, onClose, wide = false }) {
  if (!open) return null
  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={onClose}>
      <section className={`modal ${wide ? 'modal--wide' : ''}`} role="dialog" aria-modal="true" aria-label={title} onMouseDown={(event) => event.stopPropagation()}>
        <header className="modal__header">
          <h2>{title}</h2>
          <button className="icon-button" aria-label="閉じる" onClick={onClose}><X /></button>
        </header>
        <div className="modal__body">{children}</div>
      </section>
    </div>
  )
}

export function Toast({ toast, onClose }) {
  if (!toast) return null
  const Icon = toast.type === 'error' ? AlertTriangle : toast.type === 'info' ? Info : CheckCircle2
  return (
    <div className={`toast toast--${toast.type || 'success'}`} role="status">
      <Icon aria-hidden="true" />
      <div><strong>{toast.title}</strong>{toast.message ? <p>{toast.message}</p> : null}</div>
      <button aria-label="通知を閉じる" onClick={onClose}><X /></button>
    </div>
  )
}

export function LoadingBlock({ label = '処理中です' }) {
  return <span className="loading-inline"><LoaderCircle className="spin" aria-hidden="true" />{label}</span>
}

export function Field({ label, required, error, hint, children }) {
  return (
    <label className={`field ${error ? 'field--error' : ''}`}>
      <span className="field__label">{label}{required ? <em>必須</em> : null}</span>
      {children}
      {error ? <span className="field__error">{error}</span> : hint ? <span className="field__hint">{hint}</span> : null}
    </label>
  )
}
